import getCodimeHomeMeta from "@/services/meta";
import Head from "next/head";

interface Props {
  path: string;
}

const ServiceMetaHead = ({ path }: Props) => {
  const author = "코디미";
  const siteName = "Potoo";
  const serviceMetaData = getCodimeHomeMeta(path);
  const { title, description, imageUrl, serviceUrl } = serviceMetaData;

  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} key="ogTitle" />
      <meta name="description" content={description} key="description" />
      <meta property="og:description" content={description} key="ogDescription" />
      <meta property="og:type" content="article" />
      <meta property="og:article:author" content={author} />
      <meta property="og:image" content={imageUrl} key="ogImage" />
      <meta property="og:url" content={serviceUrl} key="ogUrl" />
      <meta property="og:site_name" content={siteName} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} key="twitterTitle" />
      <meta property="twitter:description" content={description} key="twitterDescription" />
      <meta property="twitter:site" content={author} />
      <meta property="twitter:image" content={imageUrl} key="twitterImage" />
      <meta property="og:article:author" content={author} />
      <link rel="canonical" href={serviceUrl} />
      <link rel="icon" href="/icons/icon.png" type="image/png" sizes="260x260" />
    </Head>
  );
};

export default ServiceMetaHead;
